module.exports = __webpack_public_path__ + "img/thumbnail_IMG_8716.jpg";